import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  el: {
    translation: {
      nav: {
        home: 'Αρχική',
        properties: 'Καταλύματα',
        areaGuide: 'Οδηγός Περιοχής',
        contact: 'Επικοινωνία',
        policies: 'Πολιτικές & Νομικά'
      },
      home: {
        hero: {
          title: 'InFox Suites',
          subtitle: 'Η ψηφιακή σας υποδοχή στη Θεσσαλονίκη και τη Χαλκιδική',
          cta: 'Εξερευνήστε τα Καταλύματα'
        },
        features: {
          title: 'Γιατί να επιλέξετε το InFox Suites',
          availability: {
            title: 'Διαθεσιμότητα σε Πραγματικό Χρόνο',
            desc: 'Ελέγξτε τη διαθεσιμότητα και κάντε κράτηση αμέσως'
          },
          payment: {
            title: 'Ασφαλής Πληρωμή',
            desc: 'Πλήρης πληρωμή ή προκαταβολή 35%'
          },
          location: {
            title: 'Εξαιρετικές Τοποθεσίες',
            desc: 'Στο κέντρο της Θεσσαλονίκης και στις παραλίες της Χαλκιδικής'
          }
        },
        featured: {
          title: 'Προτεινόμενα Καταλύματα',
          subtitle: 'Ανακαλύψτε τα επιλεγμένα καταλύματά μας',
          viewAll: 'Προβολή Όλων των Καταλυμάτων'
        },
        cta: {
          title: 'Έτοιμοι να Κλείσετε τη Διαμονή σας;',
          subtitle: 'Ζήστε την άνεση και την ευκολία των InFox Suites στη Θεσσαλονίκη και τη Χαλκιδική',
          button: 'Κάντε Κράτηση Τώρα'
        },
        loading: 'Φόρτωση καταλυμάτων...'
      },
      property: {
        perNight: 'ανά διανυκτέρευση',
        guests: 'Άτομα',
        bedrooms: 'Υπνοδωμάτια',
        size: 'Μέγεθος',
        floor: 'Όροφος',
        amenities: 'Ανέσεις',
        location: 'Τοποθεσία',
        pricing: 'Τιμολόγηση',
        bookNow: 'Κάντε Κράτηση Τώρα',
        cleaningFee: 'Καθαρισμός',
        occupancyTax: 'Φόρος Διαμονής',
        extraPerson: 'Επιπλέον Άτομο',
        minimumStay: 'Ελάχιστη Διαμονή',
        nights: 'διανυκτερεύσεις',
        highlights: 'Χαρακτηριστικά',
        viewOnMap: 'Προβολή στο Google Maps',
        checkAvailability: 'Έλεγχος Διαθεσιμότητας',
        availableUntil: 'Διαθέσιμο έως',
        viewDetails: 'Λεπτομέρειες',
        allProperties: 'Όλα τα Καταλύματα',
        notFound: 'Το κατάλυμα δεν βρέθηκε',
        backToProperties: 'Επιστροφή στα Καταλύματα',
        loadingProperty: 'Φόρτωση καταλύματος...',
        noProperties: 'Δεν βρέθηκαν καταλύματα για αυτό το φίλτρο.'
      },
      booking: {
        title: 'Ολοκληρώστε την Κράτησή σας',
        checkIn: 'Ημερομηνία Άφιξης',
        checkOut: 'Ημερομηνία Αναχώρησης',
        guests: 'Αριθμός Ατόμων',
        guestInfo: 'Στοιχεία Επισκέπτη',
        name: 'Ονοματεπώνυμο',
        email: 'Email',
        phone: 'Τηλέφωνο',
        paymentType: 'Τρόπος Πληρωμής',
        payFull: 'Πλήρης Πληρωμή (100%)',
        payDeposit: 'Προκαταβολή 35%',
        specialRequests: 'Ειδικές Απαιτήσεις',
        proceedToPayment: 'Συνέχεια στην Πληρωμή',
        priceBreakdown: 'Ανάλυση Κόστους',
        basePrice: 'Βασική Τιμή',
        total: 'Σύνολο',
        selectDates: 'Επιλογή Ημερομηνιών',
        selectDate: 'Επιλέξτε ημερομηνία',
        maxGuests: 'Μέγιστο',
        processing: 'Επεξεργασία...',
        payNow: 'Πληρωμή',
        fullPayment: 'Πλήρης πληρωμή',
        depositPayment: 'Πληρωμή 35% προκαταβολής',
        remainingCash: 'Υπόλοιπο 65% σε μετρητά κατά την άφιξη',
        securePayment: 'Ασφαλής πληρωμή μέσω Stripe. Χωρίς επιπλέον χρεώσεις.',
        depositOption: 'Εξασφαλίστε την κράτησή σας με προκαταβολή 35%. Πληρώστε το υπόλοιπο 65% σε μετρητά κατά την άφιξη.',
        fullOption: 'Πληρώστε το πλήρες ποσό τώρα. Χωρίς επιπλέον χρεώσεις.'
      },
      contact: {
        title: 'Επικοινωνήστε Μαζί Μας',
        name: 'Όνομα',
        email: 'Email',
        phone: 'Τηλέφωνο',
        message: 'Μήνυμα',
        send: 'Αποστολή',
        office: 'Γραφείο',
        officeAddress: 'Αριστοτέλους 3 & Τσιμισκή, 2ος όροφος, Θεσσαλονίκη',
        sendMessage: 'Στείλτε μας Μήνυμα',
        visitOffice: 'Επισκεφτείτε το Γραφείο μας',
        businessHours: 'Ωράριο Λειτουργίας',
        monday: 'Δευτέρα',
        friday: 'Παρασκευή',
        saturday: 'Σάββατο',
        sunday: 'Κυριακή',
        byAppointment: 'Κατόπιν ραντεβού',
        closed: 'Κλειστά',
        urgentMatters: 'Για επείγοντα θέματα εκτός ωραρίου, επικοινωνήστε μαζί μας μέσω WhatsApp.',
        luggageNote: 'Μπορείτε να αφήσετε αποσκευές ή να πραγματοποιήσετε πληρωμές στο γραφείο μας κατά τις ώρες λειτουργίας.'
      },
      footer: {
        company: 'InFox Group of Companies',
        contact: 'Επικοινωνία',
        email: 'Email',
        phone: 'Τηλέφωνο',
        whatsapp: 'WhatsApp',
        allRightsReserved: 'Όλα τα δικαιώματα διατηρούνται'
      },
      success: {
        title: 'Η Κράτηση Επιβεβαιώθηκε!',
        subtitle: 'Ευχαριστούμε που επιλέξατε το InFox Suites',
        whatNext: 'Επόμενα Βήματα',
        step1: {
          title: 'Ελέγξτε το Email σας',
          desc: 'Σας στείλαμε email επιβεβαίωσης με τις λεπτομέρειες της κράτησης και τις οδηγίες check-in.'
        },
        step2: {
          title: 'Αποθηκεύστε τα Στοιχεία',
          desc: 'Θα λάβετε οδηγίες check-in, κωδικούς πρόσβασης και πληροφορίες για το κατάλυμα πιο κοντά στην ημερομηνία άφιξής σας.'
        },
        step3: {
          title: 'Ερωτήσεις;',
          desc: 'Επικοινωνήστε μαζί μας μέσω WhatsApp στο +30 6936 547 334 ή email infoxsuites@info-x.gr'
        },
        cancellationPolicy: 'Πολιτική Ακύρωσης',
        cancellationText: 'Δωρεάν ακύρωση εάν ακυρώσετε περισσότερο από 21 ημέρες πριν την άφιξη. Εάν ακυρώσετε εντός 21 ημερών, η κράτηση καθίσταται μη επιστρεπτέα.',
        paymentConfirmation: 'Επιβεβαίωση Πληρωμής',
        amountPaid: 'Ποσό που Πληρώθηκε',
        status: 'Κατάσταση',
        paid: 'Πληρώθηκε',
        backHome: 'Επιστροφή στην Αρχική',
        browseMore: 'Περισσότερα Καταλύματα',
        leaveReview: 'Αφήστε μας μια κριτική',
        enjoyedStay: 'Απολαύσατε τη διαμονή σας; Θα χαρούμε να ακούσουμε από εσάς!',
        processing: 'Επεξεργασία της Πληρωμής σας',
        pleaseWait: 'Παρακαλώ περιμένετε ενώ επιβεβαιώνουμε την κράτησή σας...',
        paymentFailed: 'Η Πληρωμή Απέτυχε',
        paymentFailedText: 'Δεν μπορέσαμε να επεξεργαστούμε την πληρωμή σας. Παρακαλώ δοκιμάστε ξανά ή επικοινωνήστε μαζί μας για βοήθεια.',
        contactSupport: 'Επικοινωνία Υποστήριξης'
      },
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        properties: 'Properties',
        areaGuide: 'Area Guide',
        contact: 'Contact',
        policies: 'Policies & Legal'
      },
      home: {
        hero: {
          title: 'InFox Suites',
          subtitle: 'Your Digital Reception in Thessaloniki and Halkidiki',
          cta: 'Explore Properties'
        },
        features: {
          title: 'Why Choose InFox Suites',
          availability: {
            title: 'Real-Time Availability',
            desc: 'Check availability and book instantly'
          },
          payment: {
            title: 'Secure Payment',
            desc: 'Pay full or 35% deposit option'
          },
          location: {
            title: 'Prime Locations',
            desc: 'Central Thessaloniki and Halkidiki beaches'
          }
        },
        featured: {
          title: 'Featured Properties',
          subtitle: 'Discover our handpicked accommodations',
          viewAll: 'View All Properties'
        },
        cta: {
          title: 'Ready to Book Your Stay?',
          subtitle: 'Experience the comfort and convenience of InFox Suites in Thessaloniki and Halkidiki',
          button: 'Book Now'
        },
        loading: 'Loading properties...'
      },
      property: {
        perNight: 'per night',
        guests: 'Guests',
        bedrooms: 'Bedrooms',
        size: 'Size',
        floor: 'Floor',
        amenities: 'Amenities',
        location: 'Location',
        pricing: 'Pricing',
        bookNow: 'Book Now',
        cleaningFee: 'Cleaning Fee',
        occupancyTax: 'Occupancy Tax',
        extraPerson: 'Extra Person',
        minimumStay: 'Minimum Stay',
        nights: 'nights',
        highlights: 'Highlights',
        viewOnMap: 'View on Google Maps',
        checkAvailability: 'Check Availability',
        availableUntil: 'Available until',
        viewDetails: 'View Details',
        allProperties: 'All Properties',
        notFound: 'Property not found',
        backToProperties: 'Back to Properties',
        loadingProperty: 'Loading property...',
        noProperties: 'No properties found for this filter.'
      },
      booking: {
        title: 'Complete Your Booking',
        checkIn: 'Check-in Date',
        checkOut: 'Check-out Date',
        guests: 'Number of Guests',
        guestInfo: 'Guest Information',
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        paymentType: 'Payment Type',
        payFull: 'Pay Full Amount (100%)',
        payDeposit: 'Pay Deposit (35%)',
        specialRequests: 'Special Requests',
        proceedToPayment: 'Proceed to Payment',
        priceBreakdown: 'Price Breakdown',
        basePrice: 'Base Price',
        total: 'Total',
        selectDates: 'Select Dates',
        selectDate: 'Select date',
        maxGuests: 'Maximum',
        processing: 'Processing...',
        payNow: 'Pay Now',
        fullPayment: 'Full payment',
        depositPayment: 'Pay 35% deposit',
        remainingCash: 'Remaining 65% in cash on arrival',
        securePayment: 'Secure payment via Stripe. No additional fees.',
        depositOption: 'Secure your booking with a 35% deposit. Pay the remaining 65% in cash upon arrival.',
        fullOption: 'Pay the full amount now. No additional charges.'
      },
      contact: {
        title: 'Contact Us',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        send: 'Send Message',
        office: 'Office',
        officeAddress: 'Aristotelous 3 & Tsimiski, 2nd floor, Thessaloniki',
        sendMessage: 'Send Us a Message',
        visitOffice: 'Visit Our Office',
        businessHours: 'Business Hours',
        monday: 'Monday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        byAppointment: 'By appointment',
        closed: 'Closed',
        urgentMatters: 'For urgent matters outside business hours, please contact us via WhatsApp.',
        luggageNote: 'You can store luggage or make payments at our office during business hours.'
      },
      footer: {
        company: 'InFox Group of Companies',
        contact: 'Contact',
        email: 'Email',
        phone: 'Phone',
        whatsapp: 'WhatsApp',
        allRightsReserved: 'All rights reserved'
      },
      success: {
        title: 'Booking Confirmed!',
        subtitle: 'Thank you for choosing InFox Suites',
        whatNext: 'What\'s Next?',
        step1: {
          title: 'Check Your Email',
          desc: 'We\'ve sent a confirmation email with your booking details and check-in instructions.'
        },
        step2: {
          title: 'Save the Details',
          desc: 'You\'ll receive check-in instructions, access codes, and property information closer to your arrival date.'
        },
        step3: {
          title: 'Questions?',
          desc: 'Contact us via WhatsApp at +30 6936 547 334 or email infoxsuites@info-x.gr'
        },
        cancellationPolicy: 'Cancellation Policy',
        cancellationText: 'Free cancellation if you cancel more than 21 days before check-in. If you cancel within 21 days of arrival, the booking becomes non-refundable.',
        paymentConfirmation: 'Payment Confirmation',
        amountPaid: 'Amount Paid',
        status: 'Status',
        paid: 'Paid',
        backHome: 'Back to Home',
        browseMore: 'Browse More Properties',
        leaveReview: 'Leave us a review',
        enjoyedStay: 'Enjoyed your stay? We\'d love to hear from you!',
        processing: 'Processing Your Payment',
        pleaseWait: 'Please wait while we confirm your booking...',
        paymentFailed: 'Payment Failed',
        paymentFailedText: 'We couldn\'t process your payment. Please try again or contact us for assistance.',
        contactSupport: 'Contact Support'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'el', // Default to Greek
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
